import React from 'react';
import styles from './PostCardSkeleton.module.css';

function PostCardSkeleton() {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <div className={styles.avatarSkeleton}>
          <div className={styles.shimmer}></div>
        </div>
        <div className={styles.userInfoSkeleton}>
          <div className={styles.usernameSkeleton}>
            <div className={styles.shimmer}></div>
          </div>
          <div className={styles.timestampSkeleton}>
            <div className={styles.shimmer}></div>
          </div>
        </div>
      </div>
      <div className={styles.bodySkeleton}>
        <div className={styles.textLine} style={{ width: '90%' }}>
          <div className={styles.shimmer}></div>
        </div>
        <div className={styles.textLine} style={{ width: '95%' }}>
          <div className={styles.shimmer}></div>
        </div>
        <div className={styles.textLine} style={{ width: '60%' }}>
          <div className={styles.shimmer}></div>
        </div>
      </div>
      <div className={styles.footerSkeleton}>
        <div className={styles.likeButtonSkeleton}>
          <div className={styles.shimmer}></div>
        </div>
      </div>
    </div>
  );
}

export default PostCardSkeleton;
